module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Wood_MockedUp.923dc95a.jpg";